module.exports={
    home: {
    	sure:'確定',
        float:{
        	updateLabel:'棚札を更新:',
	        success:'成功する：',
	        fail:'失敗する：',
	        initMsg:'現在更新されているタグはありません'
        },
        dialog:{
        	msg:'更新された棚札ステータスを取得できませんでした'
        },
        tips:{
            chooseSys: '管理者に連絡して、目的のアプリケーションシナリオを選択してください'
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/Home.js